import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';

/**
 * Pill que marca, del lado de la agencia, una conexión/cuenta/tienda que originó y gestiona el
 * cliente desde su portal (origen = cliente). Solo informativo.
 */
export const ManagedByClientTag = ({clientName}) => {
    const {t} = useTranslation();
    return (
        <span className="role-pill -client-managed">
            <FaIcon iconName="plug"/>
            {clientName
                ? t('managed_by_client.label_named', {name: clientName})
                : t('managed_by_client.label')}
        </span>
    );
};
